export class VisitHelper {
  static update(frames, params, updateWindowLocation = true) {
    let url

    if (updateWindowLocation) {
      url = new URL(window.location)

      Object.entries(params).forEach(([key, value]) => {
        url.searchParams.set(key, value)
      })

      VisitHelper.removeEmptyParamsFromUrl(url)

      history.pushState({}, null, url.toString())
    }

    Array.of(frames).flat().forEach((frame) => {
      const turboFrame = document.querySelector(`turbo-frame#${frame}`)

      if (turboFrame) {
        url = new URL(turboFrame.src)

        Object.entries(params).forEach(([key, value]) => {
          url.searchParams.set(key, value)
        })

        VisitHelper.removeEmptyParamsFromUrl(url)

        Turbo.visit(url.toString(), { frame: frame })
      }
    })
  }

  static removeEmptyParamsFromUrl(url) {
    const searchParams = new URLSearchParams(url.search)

    Array.from(searchParams).forEach(([key, value]) => {
      if (!value) {
        url.searchParams.delete(key, value)
      }
    })
  }
}
